import { api } from '../api';
import { BrandingForm } from '../components/BrandingForm';
import { t } from '../i18n';
import { Loading, Notice, PageHeader } from '../components/ui';
import { useLoad } from '../lib/hooks';
import { SettingsTabs } from './SettingsTabs';

export function Branding({ onChanged }: { onChanged: () => void }) {
  const branding = useLoad(api.branding);

  async function after<T>(change: Promise<T>) {
    branding.setData((await change) as never);
    onChanged();
  }

  return (
    <div className="stack">
      <SettingsTabs />
      <PageHeader title={t('Branding')} description={t('Your name, colours and logo, on every screen your people see.')} />
      {branding.error && <Notice kind="error">{branding.error}</Notice>}
      {!branding.data ? (
        <Loading />
      ) : (
        <BrandingForm
          key={`${branding.data.logoVersion}-${branding.data.faviconVersion}`}
          branding={branding.data}
          imageUrl={(kind, version) => `/api/branding/${kind}?v=${version}`}
          save={(input) => after(api.updateBranding(input))}
          uploadImage={(kind, file) => after(api.uploadBrandingImage(kind, file))}
          removeImage={(kind) => after(api.deleteBrandingImage(kind))}
        />
      )}
    </div>
  );
}
